import { render, staticRenderFns } from "./FundAdminCustomized.vue?vue&type=template&id=3fa39fd8&scoped=true"
import script from "./FundAdminCustomized.vue?vue&type=script&lang=js"
export * from "./FundAdminCustomized.vue?vue&type=script&lang=js"
import style0 from "./FundAdminCustomized.vue?vue&type=style&index=0&id=3fa39fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa39fd8",
  null
  
)

export default component.exports